import { useState } from "react";
import { Outlet } from "react-router-dom";

export default function NotificationPage() {
  return (
    <div className="min-h-screen bg-[#f0f2ee]">
      <Outlet />
    </div>
  );
}
